import React from "react";
import { withTranslation } from 'react-i18next';
import { Modal } from 'react-bootstrap';
import L from "leaflet";

import MapComponent from '../Map/Map'
import Legend from './Legend'
import TileSelector from './TileSelector'
import MapSelector from './MapSelector'
import FiltersTrigger from './FiltersTrigger'

import MetaTags from 'react-meta-tags';

import "bootstrap/dist/css/bootstrap.min.css";
import '../css/static_pages.css'
import "../UI/my_spinner.css"
import { HOST, API_URL } from '../auxiliar/constants'

class VisorMain extends React.Component {

    map

    state = {
        loading: true,
        showModalFiltro: false,
        mapType: "MAP", //or SATELITE
        tileType: "CLUSTER", //or HEAT
        selectedOrigin: "SIBIC", //or EASIN
        sibicRecords: [],
        easinRecords: []
    }


    componentDidMount() {
        this.fetchInitialRecords()
    }

    async fetchInitialRecords() {
        let sibicRecords = []
        let easinRecords = []
        await fetch('https://eei.sibic.org/API/geo2.php')
            .then(response => response.json())
            .then(data => {
                sibicRecords = data.records.map(record => {
                    return {
                        lng: parseFloat(record.longitude),
                        lat: parseFloat(record.latitude),
                        type: 'SIBIC',
                        recId: record.records_id,
                        specId: record.species_id,
                        heat: [parseFloat(record.latitude), parseFloat(record.longitude), "100"]
                    }
                })
            })

            await fetch(`${HOST}${API_URL}/?function=getRecords`)
                .then(response => response.json())
                .then(data => {
                    easinRecords = data.records.map(record => {
                        let rect = L.rectangle(JSON.parse(record.polygon), {})
                        let center = rect.getBounds().getCenter()
                        return {
                            lng: center.lng,
                            lat: center.lat,
                            type: 'EASIN',
                            recId: record.recordId,
                            specId: record.speciesId,
                            heat: [center.lat, center.lng, "100"]
                        }
                    })
                })


        this.setState({
            sibicRecords: sibicRecords,
            easinRecords: easinRecords,
            loading: false
        })
    }


    handleChangeTiletype = (type) => {
        this.setState({
            tileType: type
        })
    }

    handleChangeMapType = (type) => {
        this.setState({
            mapType: type
        })
    }


    openModalFiltro = () => { this.setState({ showModalFiltro: true }); }

    closeModalFiltro = () => { this.setState({ showModalFiltro: false }); }

    renderMap = () => {

        const markers = [].concat(this.state.sibicRecords).concat(this.state.easinRecords)

        const { t } = this.props
        return (
            <div className="row">
                <MetaTags>
                    <title>{t("title-visor")}</title>
                    <meta name="description" content={t("description-visor")} />
                </MetaTags>
                <MapComponent
                        hideControl={true}
                        tileType={this.state.tileType}
                        mapType={this.state.mapType}
                        markers={markers}
                        loading={this.state.loading}
                     />
            </div>
        )
    }

    render() {
        return (
            <div className="container-fluid container_page container_VisorMain">
                { this.renderHeaderRow () }
                { this.renderMap() }
                { this.renderFiltersModal() }
            </div>
        )
    }

    renderFiltersModal = () => {
        return (
            <Modal className="modal-container bt_filtros_modal" show={this.state.showModalFiltro} onHide={this.closeModalFiltro} animation={true} >
                <Modal.Body className="p-0">
                    filtros
                </Modal.Body>
            </Modal>
        )
    }

    renderHeaderRow = () => {
        return (
            <div className="row row_filtros justify-content-end">
                <div className="col-md-5">
                    <FiltersTrigger tileType={this.state.tileType}/>
                    <MapSelector handleChangeMapType={this.handleChangeMapType} mapType={this.state.mapType} />
                    <TileSelector handleChangeTiletype={this.handleChangeTiletype} tileType={this.state.tileType} />
                    <Legend/>
                </div>
            </div>
        )
    }
}

export default withTranslation()(VisorMain)
